import $ from "jquery";
import videojs from "video.js";
import Aspiration from "@bd-utils/aspiration";
import compile from "@bd-utils/handlerbars-helper";
import copyTextToClipboard from "@bd-utils/copyTextToClipboard";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getState, subscribe } from "@bd-stores/store";
import { getPlayers, getUserFromId } from "@bd-stores/game-progress";
import { updateAttributes } from "@bd-core/firebase-actions";

export const WaitingRoom = () => {
    const isWaitingRoom = $("#page-waitingroom").length > 0;

    if (!isWaitingRoom) return false;

    const elms = {
        pageWaitingRoom: "#page-waitingroom",
        waitingroom: ".waitingroom",
        waitingroomSubtitle: ".waitingroom__subtitle",
        everyoneReadyTitle: ".js-ready-title",
        everyoneReadySubtitle: ".js-ready-subtitle",
        waitingEveryone: ".js-waiting-title",
        waitingEveryoneSubtitle: ".js-waiting-subtitle",
        readyBtn: ".js-ready-btn",
        cancelBtn: ".js-cancel-btn",
        messageboxForm: ".js-messagebox-form",
        messageboxName: ".js-messagebox-name",
        messageboxAvatar: ".js-messagebox-avatar",
        messageboxMsg: ".js-messagebox-message",
        messageboxSubmit: ".js-messagebox-submit",
        member: ".member",
        memberEmailValue: ".member-email span",
        startBtn: ".js-start-game",
        countdownSecond: ".waitingroom-countdown-timer .second .column.animate",
        countdownSecondNum:
            ".waitingroom-countdown-timer .second .column.animate .num",
        introVideo: "#intro-video",

        playerList: ".js-player-list",
        playerItem: ".js-player-item",
        deletePlayerBtn: ".js-player-item-delete",
        teamName: ".js-team-name",
        gameInfoLeave: ".js-leave-team",

        teamId: ".teamId",
        teamIdCopy: ".js-copy-team-id",
        teamIdValue: ".js-team-id-value",

        gameInfo: ".gameInfo",
        gameInfoBtn: ".gameInfo__btn",

        leaderPopup: ".js-leader-popup",

        // setup profile elements
        profileWrapper: ".profileBox",
        avatarWrapper: ".setAvatar",
        avatarImg: ".js-avatar",
        inputNameWrapper: ".setName",
        inputNickname: ".js-nickname",
        displayName: ".profileDisplay__name",
        displayAvatar: ".profileDisplay__avatar",
        avatarUpload: ".js-avatar-upload",
        uploadPreview: ".js-upload-preview",
        avatarUploadFilename: ".js-filename-avatar",
        submitProfile: ".js-save-profile",
        editProfileBtn: ".js-edit-profile",

        aspirationWall: ".js-aspiration-wall",
        aspirationPerson: ".aspiration__person",
    };

    /**
     * Get relative path of a url without the site / hostname
     *
     * @param {string} url
     */
    const getRelativeUrl = (url) => {
        const site = CONFIG.siteURL;
        return url.replace(site, "");
    };

    /**
     * Check is given url provided from avatar options or is it custom upload.
     * false mean it's provided avatar, true means it's custom upload
     *
     * @param {string} url file url to check
     */
    const checkIsCustomAvatar = (url) => {
        const options = CONFIG.avatarOptions;

        if (options.length < 1) return false;

        const getUrl = (k) => getRelativeUrl(options[k]);
        const provided = Object.keys(options).map((k) => getUrl(k));
        return !provided.includes(url);
    };

    const getIsCompleteProfile = () => {
        const user = getUserFromId(CONFIG.user.id);
        const isFilledName = $(elms.inputNickname).val() !== "";
        // const isSelectedAvatar = CONFIG.user.avatar?.length > 0;

        const players = getPlayers();
        const myData = players.find((p) => p.userId === user?.userId);
        const hasSetupProfile = Boolean(myData?.hasSetupProfile);
        const isCompleteProfile = isFilledName && hasSetupProfile;

        return isCompleteProfile;
    };
    const render = (rawData = {}) => {
        const user = getUserFromId(CONFIG.user.id);
        const isUploadAvatar = checkIsCustomAvatar(user.avatarURL);
        const isCompleteProfile = getIsCompleteProfile();

        const avatarOptions = Object.keys(CONFIG.avatarOptions).map((k) => ({
            value: k,
            url: CONFIG.avatarOptions[k],
            isSelected:
                isCompleteProfile && isUploadAvatar
                    ? false
                    : getRelativeUrl(CONFIG.avatarOptions[k]) ===
                      user.avatarURL,
        }));

        const data = {
            ...rawData,
            teamCode: CONFIG.firebase.team_code.toUpperCase(),
            isUploadAvatar,
            avatarOptions,
            user: getUserFromId(CONFIG.user.id),
        };

        const template = $("#page-waitingroom-template").html();
        const html = compile(template, data);
        $("#page-waitingroom").html(html);
    };

    let aspiration = null;
    const renderAfterInitialized = () => {
        let hasRendered = false;

        subscribe(() => {
            const store = getState();
            if (!store.userProgress.isFirebaseInitialized) return;
            if (store.gameProgress.players.length < 1) return;
            if (hasRendered) return;
            hasRendered = true;

            render(getState().pageWaitingRoom);
            aspiration = new Aspiration();
            aspiration.setup();
        });
    };

    renderAfterInitialized();

    const updateUI = () => {
        const isCompleteProfile = getIsCompleteProfile();
        $(elms.profileWrapper).toggleClass("is-profile-set", isCompleteProfile);
        $(elms.pageWaitingRoom).toggleClass(
            "is-profile-set",
            isCompleteProfile,
        );
        $(elms.messageboxMsg).prop("disabled", !isCompleteProfile);
    };

    subscribe(() => {
        updateUI();
    });

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame().then(() =>
            setTimeout(() => {
                $(".aspiration").animate(
                    { scrollTop: $(".aspiration__wall").prop("scrollHeight") },
                    300,
                );
            }, 400),
        );
    } catch (e) {
        console.error(e);
    }
    //----------------------------------------------------------------------- End Initialize Firebase

    // ------------------------------------------------------------------- WAITING ROOM

    let isLoading = false;
    let isReady = false;
    const onPlayerStateChange = (e, eData) => {
        if (!eData || !eData.data) return;

        //handle ready state
        isReady = eData.data.ready;
        $("#page-waitingroom").toggleClass("is-ready", isReady);
        const newText = isReady ? "I am ready" : "Ready?";

        $(elms.readyBtn).find(".ready-text").text(newText);
        $(elms.readyBtn).toggleClass("is-ready", isReady);
    };

    bdjs.listen("bd__playerStateChanged", onPlayerStateChange);

    //On players changed
    //-------------------------------------------------------------------------
    let isLeaving = false;
    let kickedPopup = false;
    const updatePlayersOrKickMe = (players) => {
        const htmlTemplate = $("#tpl-user-item").html();

        const htmlPlayers = players.reduce((result, rawPlayer) => {
            const { siteURL, game, user } = CONFIG;
            const player = {
                ...rawPlayer,
                avatarURL: `${siteURL}${rawPlayer.avatarURL}`,
                is_leader: game.is_leader && user.id == rawPlayer.userId,
                isOffline: !rawPlayer.isOnline,
                isMe: rawPlayer.userId === user.id
            };

            return rawPlayer.userId
                ? `${result}${compile(htmlTemplate, player)}`
                : result;
        }, "");

        $(elms.playerList).html(htmlPlayers);

        //check for kicked players
        const isCurrentPlayerExist =
            players.filter((p) => p.userId === CONFIG.user.id).length > 0
                ? true
                : false;

        const $snackbar = $(".snackbar");
        if (!isCurrentPlayerExist && !isLeaving && !kickedPopup) {
            kickedPopup = true;
            $snackbar
                .find(".js-snackbar-body")
                .html(
                    window.CFG?.strings.removedFromTeam,
                );
            $snackbar.addClass("is-active");

            setTimeout(function () {
                window.location.reload();
            }, 3000);
            return false;
        }
    };

    const maybeReadyToStart = (players) => {
        let allReady = false;
        if (Array.isArray(players)) {
            let validPlayers = 0;
            let readyPlayers = 0;

            players.forEach((player) => {
                if (player.ready) readyPlayers++;
                if (player.userId) validPlayers++;
            });

            if (players.length >= 1) {
                allReady = readyPlayers >= 1 && readyPlayers == validPlayers;
            }

            if (CONFIG.game.game_prop.singlePlayer && readyPlayers > 0) {
                allReady = true;
            }
        }

        $(elms.waitingroomSubtitle).toggleClass("hide", allReady);

        if (allReady) {
            $(elms.everyoneReadyTitle).show();
            $(elms.everyoneReadySubtitle).show();

            $(elms.waitingEveryone).hide();
            $(elms.waitingEveryoneSubtitle).hide();
        } else {
            $(elms.everyoneReadyTitle).hide();
            $(elms.everyoneReadySubtitle).hide();

            $(elms.waitingEveryone).show();
            $(elms.waitingEveryoneSubtitle).show();
        }

        $(elms.startBtn).prop("disabled", !allReady);
    };

    const updateAspirationProfile = function (players) {
        // update avatar and name on aspiration wall
        const $aspirationWall = $(elms.aspirationWall);

        players.forEach(function (player) {
            const hasMessage = $aspirationWall
                .children()
                .find(
                    elms.aspirationPerson + `[data-user-id=${player.userId}]`,
                );

            if (hasMessage.length > 0) {
                $.each(hasMessage, function (index, msg) {
                    $(msg)
                        .find(".aspiration__avatar")
                        .attr("src", player.avatarURL);
                    $(msg).find(".aspiration__name").text(player.name);
                });
            }
        });
    };

    const onPlayersStateChanged = (e, eData) => {
        /* Update players DOM */
        const players = eData?.data;
        updatePlayersOrKickMe(players);
        maybeReadyToStart(players);
        updateAspirationProfile(players);
    };

    bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);

    // On Team Data Changed
    // ------------------------------------------------------------------------
    const maybeTeamNameChanged = (teamData) => {
        if (
            $(elms.pageWaitingRoom).hasClass("is-leader") ||
            !teamData?.teamname
        )
            return;

        $(elms.teamName).val(teamData?.teamname);
    };

    const maybeTeamLeaderChanged = (teamData) => {
        const leaderId = teamData?.leader;

        if (!leaderId) return;

        const $elLeader = $(
            elms.playerItem.concat(`[player-id="${leaderId}"]`),
        );
        const leaderText = $(elms.playerList).attr("data-leader-text");
        const htmlLeader = `<div class="gamePlayer__teamLeader">${leaderText}</div>`;

        $elLeader.find(".js-leader-text").html(htmlLeader);

        if (leaderId == CONFIG.user.id && !CONFIG.game.is_leader) {
            CONFIG.game.is_leader = true;
            $(elms.leaderPopup).addClass("is-open");
            $(elms.pageWaitingRoom)
                .removeClass("is-member")
                .addClass("is-leader");
            $(elms.teamName).removeAttr("readonly");
            $elLeader.find(elms.deletePlayerBtn).addClass("hidden");
        }
    };

    let alreadyStarted = false;
    const maybeStartTheGame = (teamData) => {
        if (!teamData?.isStarting || alreadyStarted) return;

        let countdownIndex = 0;  // Start index from 0, which corresponds to 5
        let countdownInterval;
        let isVideoError = false;

        alreadyStarted = true;

        const startTheGame = async () => {
            const isLeader = $("#page-waitingroom").hasClass("is-leader");

            bdjs.showLoading();
            await bdjs.goAsync(bdapi.post("game/start-game"));

            setTimeout(() => {

                // set timer attributes for leader only
                if(isLeader) {
                    const timeLimit = CONFIG.game.cfgLimit.timeLimit || 0;
                    const startedAt = Math.floor(Date.now() / 1000);
                    const shouldFinishAt = startedAt + timeLimit * 60;
                    const allocatedBudget = CONFIG.game.allocated_budget || 45000000;
                    const spendingBudget = 0;
    
                    updateAttributes({
                        startedAt,
                        shouldFinishAt,
                        allocatedBudget,
                        spendingBudget
                    });
                }

                document.location.href = CONFIG.mainRoom;
            }, GameLogic.transisitonDuration);
        };

        const introVideo = videojs("intro-video", {
            controls: true,
            autoplay: false,
            preload: "auto",
        });

        introVideo.on("ended", function () {
            startTheGame();
        });

        introVideo.on("error", function () {
            isVideoError = true;
        });

        const stopInterval = () => {
            clearInterval(countdownInterval);

            if (isVideoError) {
                startTheGame();
                return;
            }

            $(elms.pageWaitingRoom).addClass("is-playing-intro");

            try {
                introVideo.play().catch((error) => {
                    console.error("Unable to start auto play", error);
                });
            } catch (error) {
                console.error(error);
            }
        };

        const updateCountdown = () => {
            const $countDownSecondNum = $(".countdown__num");
            const outerHeight = $countDownSecondNum.outerHeight(true);
            const newTranslate = 0 - countdownIndex * outerHeight;

            if (countdownIndex === 0) {
                $(".countdown__column.zero").css({
                    transform: "translateY(" + newTranslate + "px)",
                });
            }

            $(".countdown__column.animate").css({
                transform: "translateY(" + newTranslate + "px)",
            });

            if (countdownIndex < 5) {
                countdownIndex++;
            } else {
                stopInterval();
            }
        };

        const startCountdown = () => {
            updateCountdown();  // Update immediately
            countdownInterval = setInterval(updateCountdown, 1000);  // Update every second
        };

        $(elms.pageWaitingRoom).addClass("is-countdown");
        startCountdown();
    };

    const onTeamStateChanged = (e, eData) => {
        const teamData = eData?.data;

        maybeTeamNameChanged(teamData);
        maybeTeamLeaderChanged(teamData);
        maybeStartTheGame(teamData);
    };

    bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);

    // Setup Team state on first load
    // ------------------------------------------------------------------------
    const setTeamInitialState = (e, eData) => {
        const teamData = eData?.data;
        $(elms.teamName).val(teamData?.attributes?.teamname || "");
    };

    bdjs.listen("bd__teamInitialState", setTeamInitialState);

    // Copy team id
    // ------------------------------------------------------------------------
    const onCopyTeamId = () => {
        const teamID = String($(elms.teamIdValue).val());
        const isCopied = copyTextToClipboard(teamID);
        if (!isCopied) return false;

        $(elms.teamId).addClass("is-copied");
        setTimeout(() => $(elms.teamId).removeClass("is-copied"), 1000);
    };

    // set team name on input
    // ------------------------------------------------------------------------\

    let timeToWait = 2; //seconds

    /**
     * @type {ReturnType<typeof setInterval> | undefined}
     */
    let intervalUpdate = undefined;

    $(document).on("input", elms.teamName, function () {
        const value = $(this).val();

        clearInterval(intervalUpdate);
        timeToWait = 2;
        intervalUpdate = setInterval(() => {
            timeToWait--;

            if (timeToWait <= 0) {
                clearInterval(intervalUpdate);

                fb.update(fb.teamAttributesPath, {
                    teamname: String(value).trim(),
                });
            }
        }, 1000);
    });

    // Kick player
    const onKickMember = async (e) => {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        const isLoading = $btn.hasClass("is-loading");
        if (isLoading) return false;

        const $playerToDelete = $btn.parents(elms.playerItem);
        const memberID = $playerToDelete.attr("player-id");
        if ($btn.hasClass("is-loading")) return;

        $btn.addClass("is-loading");

        await bdjs.goAsync(
            bdapi.post("member/kick-member", { member_id: memberID }),
        );

        $btn.removeClass("is-loading");
    };

    // Onboarding Box
    // ------------------------------------------------------------------------
    // let isLoading = false;
    const onToggleReady = () => {
        fb.update(fb.currentPlayerPath, {
            ready: !isReady,
        });
    };

    // Aspiration Box
    // ------------------------------------------------------------------------
    /**
     * Add message to firebase to be shown on aspiration
     * @param {string} message
     */
    const addMessage = (message) =>
        fb.push(fb.chatsPath, {
            userId: CONFIG.user.id,
            message,
        });

    const onAddMessage = (e) => {
        e.preventDefault();
        const message = String($(elms.messageboxMsg).val()).trim();
        if (message.length < 1) return false;

        addMessage(message);
        $(elms.messageboxMsg).val("");
        $(elms.messageboxSubmit).prop("disabled", true);
    };

    const manageChat = (e, eData) => {
        const msgData = eData.data;
        const players = getPlayers();
        if (!players.length) return;

        const sender = players.find(
            (p) => p?.userId && msgData?.userId && p.userId === msgData.userId,
        );

        if (sender) {
            const classes = sender?.userId == CONFIG.user.id ? ["is-me"] : [];
            aspiration.append(
                sender.userId,
                sender.name,
                msgData.message,
                sender.avatarURL,
                classes,
                msgData.isNew,
            );
        }
    };

    bdjs.listen("bd__onChatSubmmited", manageChat);

    $(document).on("keypress", elms.messageboxMsg, function (e) {
        const key = e.which || e.keyCode || 0;
        const isEnterKey = key == 13;
        if (isEnterKey && !e.shiftKey) {
            e.preventDefault();
            $(elms.messageboxForm).trigger("submit");
            return false;
        }
    });

    $(document).on("input", elms.messageboxMsg, function () {
        const value = String($(this).val());
        const isDisabled = value.length < 1;
        $(elms.messageboxForm).find("button").prop("disabled", isDisabled);
    });

    // Countdown button start the game
    // ------------------------------------------------------------------------
    $(document).on("click", elms.startBtn, (e) => {
        e.preventDefault();

        // const timeLimit = CONFIG.game.cfgLimit.timeLimit || 0;
        // const startedAt = Math.floor(Date.now() / 1000);
        // const shouldFinishAt = startedAt + timeLimit * 60;

        fb.update(fb.teamAttributesPath, { 
            isStarting: true,
            // startedAt,
            // shouldFinishAt
        });
    });

    // Leave Game
    // ------------------------------------------------------------------------
    const onLeaveTeam = async (e) => {
        e.preventDefault();

        if (isLoading) return false;
        const message = "Are you sure you want to leave the team?";
        const confirm_result = confirm(message);

        if (!confirm_result) {
            return false;
        }

        const $this = $(e.currentTarget);

        $this.addClass("is-loading");
        isLoading = true;
        isLeaving = true;

        await bdjs.goAsync(bdapi.post("member/leave-team"));
        window.location.reload();
        return false;
    };

    // Leader Popup
    // ------------------------------------------------------------------------

    const closeLeaderPopup = function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.parents(elms.leaderPopup).removeClass("is-open");
    };

    $(elms.leaderPopup)
        .find(".js-completionPopup-close")
        .on("click", closeLeaderPopup);

    $(document).on("click", elms.teamIdCopy, onCopyTeamId);
    $(document).on("click", elms.deletePlayerBtn, onKickMember);
    $(document).on("click", elms.readyBtn, onToggleReady);
    $(document).on("click", elms.cancelBtn, onToggleReady);
    $(document).on("click", elms.gameInfoLeave, onLeaveTeam);
    $(document).on("submit", elms.messageboxForm, onAddMessage);
    GameLogic.listenGameProgressChanged();
};
